import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import createContextMenuOption from './createContextMenuOption';
/**
 * @typedef Props
 * @property {import('data/types').DataGridViewState<any>} grid
 * @property {React.ComponentType} Component
 */

/**
 * @param {Props} props
 */

var ItemContextMenu = function ItemContextMenu(_ref) {
  var Component = _ref.Component,
      grid = _ref.grid,
      props = _objectWithoutProperties(_ref, ["Component", "grid"]);

  var _useState = useState({
    anchorReference: null,
    anchorEl: null,
    anchorPosition: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      anchor = _useState2[0],
      setAnchor = _useState2[1];

  var isOpen = Boolean(anchor.anchorEl || anchor.anchorPosition);

  var open = function open(e, item, info) {
    if (info && info.origin === 'button') {
      setAnchor({
        anchorPosition: null,
        anchorEl: e.currentTarget,
        anchorReference: 'anchorEl'
      });
    } else {
      setAnchor({
        anchorEl: null,
        anchorPosition: {
          left: e.clientX,
          top: e.clientY
        },
        anchorReference: 'anchorPosition'
      });
    }

    e.preventDefault();
  };

  var close = function close() {
    setAnchor({
      anchorEl: null,
      anchorPosition: null,
      anchorReference: null
    });
  };
  /** @type any */


  var compProps = _objectSpread({
    onContextMenu: open
  }, props);

  if (isOpen) {
    compProps.selected = true;
    compProps.contextMenuOpened = true;
  }

  var menuEntries = grid.contextMenu.map(function (e) {
    return createContextMenuOption(e, compProps.item, compProps.config);
  });
  return React.createElement(React.Fragment, null, React.createElement(Component, Object.assign({
    showContextMenuIcon: true
  }, compProps)), React.createElement(Menu, Object.assign({
    MenuListProps: {
      dense: true
    },
    id: "item-ctx-menu",
    open: isOpen,
    onClose: close
  }, anchor), menuEntries.map(function (entry, idx) {
    if (entry.hidden) return null;
    if (entry.type === 'separator') return React.createElement(Divider, {
      key: idx
    });
    return React.createElement(MenuItem, {
      key: idx,
      onClick: function onClick(e) {
        close();
        entry.onClick(e, compProps.item, compProps.config);
      }
    }, entry.label);
  })));
};

var CACHE_GRIDS = {};
/**
 * @param {import('data/types').DataGridViewState<any>} grid
 */

var addItemContextMenu = function addItemContextMenu(Component, grid, ctxId) {
  if (!grid) {
    throw new Error('Missing definition. Most likely you passed a wrong dataType to DataGrid component.');
  }

  if (!grid.contextMenu) return Component;
  if (CACHE_GRIDS[ctxId]) return CACHE_GRIDS[ctxId];
  /**
   *
   * @param {any} props
   */

  var ComponentWithContext = function ComponentWithContext(props) {
    return React.createElement(ItemContextMenu, Object.assign({}, props, {
      Component: Component,
      grid: grid
    }));
  };

  CACHE_GRIDS[ctxId] = ComponentWithContext;
  return ComponentWithContext;
};

export default addItemContextMenu;